module.exports = __webpack_public_path__ + "6adf53223cebe5cb6fec28598acf3199.pdf";